import { MilestoneToBeBilled } from '@/services/billing/types/billing.type';
import { Box, Card } from '@mui/material';
import { MilestoneAccordionItem } from './milestone-accordion-item';

export interface MilestoneAccordionItemListProps {
  milestones: MilestoneToBeBilled[];
}
export const MilestoneAccordionItemList = ({ milestones }: MilestoneAccordionItemListProps) => {
  return (
    <Box sx={{ mb: 2 }}>
      <Card variant="outlined" sx={{ cursor: 'pointer' }}>
        {milestones.map((milestone) => (
          <MilestoneAccordionItem key={milestone._id} milestone={milestone} />
        ))}
      </Card>
    </Box>
  );
};
